import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DiseasesService } from '../services/diseases.service';
import { SharedService } from '../services/shared.service';

@Injectable({
  providedIn: 'root',
})
export class PatientsearchService {
  constructor(private http: HttpClient, private diseaseService: DiseasesService) {}

  patientDetailsForMobile(data) {
    return this.http.post('/cphm/v2/search/doSearch', data);
  }
  patientDetailsForQuickSearch(data) {
    return this.http.post('/cphm/v2/search/doEasySearch', data);
  }

  patientDetails(patientInput) {
    return this.http.get(
      'cphm/v2/search/doSearch?limit=' +
        patientInput.limit +
        '&offset=' +
        patientInput.offset +
        '&phoneNumber=' +
        patientInput.phoneNo +
        '&idType=' +
        patientInput.idType +
        '&idValue=' +
        patientInput.idValue +
        '&districtId=' +
        patientInput.districtId +
        '&talukaId=' +
        patientInput.talukaId +
        '&phcId=' +
        patientInput.phcId +
        '&subcenterId=' +
        patientInput.subcenterId +
        '&villageId=' +
        patientInput.villageId +
        '&name=' +
        patientInput.firstName +
        '&headName=' +
        patientInput.hofName +
        '&dob=' +
        patientInput.dob +
        '&fatherOrSpouseName=' +
        patientInput.fatherOrSpouseName +
        '&ageFrom=' +
        patientInput.ageFrom +
        '&ageTo=' +
        patientInput.ageTo
    );
  }
  getVillage(villageName, locationId, type) {
    return this.http.get<any[]>(
      '/cphm/readOnly/admin/adminGeneral/villageSearch?villageName=' + villageName + '&' + type + '=' + locationId
    );
  }

  getTalukPhcSuncenter(locationType, locationId) {
    return this.http.get<any[]>(
      '/cphm/ms2/custom-summary?locationType=' +
        locationType +
        '&locationId=' +
        locationId +
        '&isSpecific=no&summaryType=hierarchy&gender=All&dashboardtype=all'
    );
  }

  getUserHierarchy() {
    return this.http.get<any>('/cphm/admin/adminGeneral/userLocationHierarchy');
  }

  getDiseaseStatus(indivisualId) {
    return this.http.get<any[]>('/cphm/v2/search/conditionStatus/' + indivisualId);
  }

  getPhoto(indivisualId) {
    return this.http.get('cphm/v2/search/photo/' + indivisualId);
  }

  getStatus() {
    return this.http.get('/cphm/v2/search/statuses');
  }

  getScreeningData(individualId) {
    return this.http.get('/cphm/php/screeningdetails/individual/' + individualId);
  }

  getMatchingSubCenters(subcentername) {
    return this.http.get('/cphm/readOnly/admin/v1/admin/location/subcenters/' + subcentername);
  }

  doctorportaldashboard(dashBoardApiInput) {
    return this.http.get(
      '/cphm/ms2/custom-summary' +
        '?locationType=' +
        dashBoardApiInput.locationType +
        '&locationId=' +
        dashBoardApiInput.locationId +
        '&isSpecific=' +
        dashBoardApiInput.isSpecific +
        '&filterType=' +
        'month' +
        '&filter=' +
        dashBoardApiInput.yearmonth +
        '&filteredResult=' +
        true +
        (dashBoardApiInput.locationType === 'SUBCENTER' ? '&summaryType=mo' : '&summaryType=mo') +
        (dashBoardApiInput.summaryType ? dashBoardApiInput.summaryType : '') +
        'dashboard&gender=All'
    );
  }
  getFacilityType(chart) {
    if(chart.catchmentType) {
      return chart.catchmentType;
    }
    const facilityType = sessionStorage.getItem('facilityType');
    let type = "";
    if (facilityType == 'PHC') type = "'7004'";
    if (facilityType == 'TALUKA') type = "'7003'";
    if (facilityType == 'CHC' || facilityType == 'DH') type = "'7002'";
    if (!type) type = "'7005'";
    return type;
  }
  updatedDate() {
    const url = window.location.hostname === 'localhost' ? 'http://127.0.0.1:9988' : '/dashpanel';
    return this.http.get(url+`/api?section=ncd_program_analysis&view=reporting&chart=last_updated_time&program=all&hwc=all&urbanphc=&disease=&location_state_id=all&location_district_id=all&location_taluka_id=all&location_phc_id=all&location_subcenter_id=all&location_village_id=all&age_range=all&gender=all&cbac=all&facility=&indicator=&level=&section=ncd_program_analysis`)
  }
  newdoctorportaldashboard(input) {
    const url = window.location.hostname === 'localhost' ? 'http://127.0.0.1:9988' : '/dashpanel';
    const catchmentType = this.getFacilityType(input);
    return this.http.get(url+`/api?section=${input.section}
    &view=${input.view}
    &chart=${input.chart}
    &program=all
    &hwc=all
    &catchment_type=${catchmentType}
    &urbanphc=
    &disease=
    &catchment_type=${catchmentType}
    ${input.returnType? '&return_type='+input.returnType: ''}
    ${input.locationType ? '&location_type='+ input.locationType: ''}
    ${input.locationType == 'DH' || input.locationType == 'CHC' ? '&location_facility_id='+input.locationTypeId : ''}
    &location_state_id=${input.stateId?input.stateId: 'all'}
    &location_district_id=${input.districtId?input.districtId: 'all'}
    &location_taluka_id=${input.talukaId?input.talukaId: 'all'}
    &location_phc_id=${input.phcId?input.phcId: 'all'}
    &location_subcenter_id=${input.subcenterId?input.subcenterId: 'all'}
    &location_village_id=${input.villageId?input.villageId: 'all'}
    &age_range=all
    &gender=all
    &cbac=all
    &facility=
    &indicator=
    &level=
    &
    abcde=`)
  }
}
